export default "__VITE_ASSET__BkdaQl2z__"